/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react'
import { notification, Result } from 'antd'
import { Link, useLocation } from 'react-router-dom'
import qs from 'query-string'
import { API, graphqlOperation } from 'aws-amplify'
import { updateBootcamp } from '../graphql/mutations'

const BootcampPaymentSuccess = () => {
  const location = useLocation()
  const { status, tx_ref } = qs.parse(location.search)
  const [loading, setLoading] = useState(true)
  const isSuccess = status === 'successful'

  const updateBootcampPayment = async () => {
    setLoading(true)
    const id = window.localStorage.getItem('bootcamp-id')
    try {
      await API.graphql(
        graphqlOperation(updateBootcamp, {
          input: {
            id,
            payment: { status, txRef: tx_ref }
          }
        })
      )
      setLoading(false)
      window.localStorage.removeItem('bootcamp-id')
    } catch (error) {
      setLoading(false)
      notification.error({
        message: 'Something went wrong',
        description: 'Please Screenshot and report this error using the "Contact Us" form',
        duration: 6000
      })
    }
  }

  useEffect(() => {
    updateBootcampPayment()
  }, [])

  return (
    <div
      style={{
        position: 'relative',
        height: '70vh',
        width: '100vw'
      }}
    >
      {loading && (
        <div className='h-screen fixed bg-black inset-0 bg-opacity-50 grid place-content-center'>
          <i className='fa fa-spin text-white fa-spinner text-xl' />
        </div>
      )}
      <Result
        status={isSuccess ? 'success' : 'error'}
        title={
          isSuccess
            ? 'Payment was successful!'
            : 'Payment was not successful but we will reach out to you soon'
        }
        style={{
          textAlign: 'center',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -70%)'
        }}
        subTitle={
          <>
            <h2 className='text-base'>Your payment was successful, we will keep in touch</h2>
          </>
        }
        extra={[
          <Link
            to='/'
            key='console'
            className='font-manrope cursor-pointer duration-200 py-3 px-6 hover:bg-opacity-75 sm:mr-5 bg-green-600 text-white hover:text-white font-semibold rounded'
          >
            Back To Website
          </Link>
        ]}
      />
    </div>
  )
}

export default BootcampPaymentSuccess
